import { Col, Divider, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ControlFailureSectionProp } from ".";
import { AMOUNT_UTIL } from "../../../../../utils/amount.utils";


const DirectImpactViewSection = (props: ControlFailureSectionProp) => {

    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">
            <Row>
                <Col span={24}>
                    <Form.Item>
                        <Row>
                            <Col span={16}>
                                <label className="form-label">{t("ControlFailure.lbDirectLossAmount")}</label>
                            </Col>
                            <Col span={8}>
                                <p className="text-amount">
                                    {AMOUNT_UTIL.convertNumericToFormattedAmount(data.direct_loss_amount)}
                                </p>
                            </Col>
                        </Row>

                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbDirectLossComments")}
                    >
                        <span>{data.direct_loss_comments}</span>
                    </Form.Item>
                </Col>

            </Row>


            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbDirectLossType")}
                    >
                        <span>{data.direct_loss_type?.name}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item>
                        <Row>
                            <Col span={16}>
                                <label className="form-label">{t("ControlFailure.lbExcessExpensesAmount")}</label>
                            </Col>
                            <Col span={8}>
                                <p className="text-amount">
                                    {AMOUNT_UTIL.convertNumericToFormattedAmount(data.excess_expenses_amount)}
                                </p>
                            </Col>
                        </Row>

                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbExcessExpensesComments")}
                    >
                        <span>{data.excess_expenses_comments}</span>
                    </Form.Item>
                </Col>

            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item>
                        <Row>
                            <Col span={16}>
                                <label className="form-label">{t("ControlFailure.lbForgoneRevenueAmount")}</label>
                            </Col>
                            <Col span={8}>
                                <p className="text-amount">
                                    {AMOUNT_UTIL.convertNumericToFormattedAmount(data.forgone_revenue_amount)}
                                </p>
                            </Col>
                        </Row>

                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbForgoneRevenueComments")}
                    >
                        <span>{data.forgone_revenue_comments}</span>
                    </Form.Item>
                </Col>

            </Row>

            <Row gutter={[16, 12]}>
                <Col offset={8} span={16}>
                    <Divider />
                </Col>
            </Row>

            <Form.Item>
                <Row>
                    <Col span={24} className="text-total">
                        <p className="red-text">{t("ControlFailure.lbTotalGrossLoss")}</p>
                        <span className="red-text">
                            {AMOUNT_UTIL.convertNumericToFormattedAmount(data.total_gross_loss)}
                        </span>
                    </Col>
                </Row>
            </Form.Item>


            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbOtherComments")}
                    >
                        <span>{data.other_comments}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbGeneralLedgerImpact")}
                    >
                        <span>{data.gl_impact ? t("ControlFailure.lbYes") : t("ControlFailure.lbNo")}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbImpact")}
                    >
                        <span>
                            {AMOUNT_UTIL.convertNumericToFormattedAmount(data.impact_amount)}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbAccountNumber")}
                    >
                        <span>{data.account_number}</span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default DirectImpactViewSection;